module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image14e.e44f724d.jpg";